import React from "react";
import "../Style/DeleteAccount.css";

const steps = [
  {
    id: 1,
    text: (
      <>
        Send an email with your <strong>registered mobile number</strong> and
        subject line <strong>"Account Deletion Request"</strong>
      </>
    ),
  },
  {
    id: 2,
    text: (
      <>
        Our team will verify your identity and send a confirmation to your
        registered contact within <strong>2 business days</strong>
      </>
    ),
  },
  {
    id: 3,
    text: (
      <>
        Once confirmed, your account and all associated data will be permanently
        removed within <strong>7 business days</strong>
      </>
    ),
  },
];

export default function DeleteAccount() {
  return (
    <div className="da-page">
      <div className="da-card">
        {/* Title */}
        <h1 className="da-title">Remove User Account</h1>

        {/* Mail Icon */}
        <div className="da-icon-wrapper">
          <svg
            className="da-mail-icon"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="2"
              y="4"
              width="20"
              height="16"
              rx="2"
              stroke="#c084c0"
              strokeWidth="1.8"
              fill="none"
            />
            <polyline
              points="2,4 12,13 22,4"
              stroke="#c084c0"
              strokeWidth="1.8"
              fill="none"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        {/* Subtitle */}
        <h2 className="da-subtitle">Want to delete your account?</h2>
        <p className="da-description">
          To request account deletion, please send an email to us at the address
          below
          <br />
          with your registered mobile number and the reason for deletion.
        </p>

        {/* Contact Box */}
        <div className="da-contact-box">
          <span className="da-contact-label">CONTACT US AT</span>
          <a href="mailto:support@mpeoples.in" className="da-contact-email">
            support@mpeoples.in
          </a>
        </div>

        {/* Steps */}
        <div className="da-steps">
          {steps.map((step) => (
            <div key={step.id} className="da-step">
              <span className="da-step-number">{step.id}</span>
              <p className="da-step-text">{step.text}</p>
            </div>
          ))}
        </div>

        {/* Warning Banner */}
        <div className="da-warning">
          <span className="da-warning-icon">⚠</span>
          <p className="da-warning-text">
            Please note: This action is <strong>irreversible</strong>. All your
            data, history, and preferences will be permanently deleted and
            cannot be recovered.
          </p>
        </div>
      </div>
    </div>
  );
}